import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { MDBBtn } from 'mdbreact';

import { ObtenerListaMarcasTecdocEnAPI } from "../action/actionCreatorsRequests"
import 'antd/dist/antd.css';

import { Drawer, Row, Col, Select, Input, Checkbox } from 'antd';
import { traducirPagina } from "../librerias/funciones"
import store from '../store'
import {
    CloseOutlined,
    SearchOutlined
} from '@ant-design/icons';
const { Option } = Select;


const ManteniminetoMarcas = ({ props, configApp, codmotorizacion }) => {
    const [hayMarcasVehiculo, setHayMarcasVehiculo] = React.useState(false);
    const [obtenerMarcasVehiculo, setObtenerMarcasVehiculo] = React.useState([]);
    const [obtenerMarcasVehiculoAux, setObtenerMarcasVehiculoAux] = React.useState([]);


    const modelarDatos = (marcas) => {
        let listaMarca = [];
        let objetoNuevoMarcas = [];
        let contAux = 0;

        for (var i = 0; i < marcas.length; i++) {
            contAux += 1;
            if (contAux <= 3) {
                listaMarca.push({ "Codigo": marcas[i].ID, "Marca": marcas[i].MARCA, "Imagen": "" })
                if ((marcas.length - 1) === i) {
                    objetoNuevoMarcas.push({ "lista": listaMarca });
                }
            } else {
                objetoNuevoMarcas.push({ "lista": listaMarca });
                contAux = 0;
                listaMarca = []
                i = (i - 1)
            }
        }
        return objetoNuevoMarcas.length === 0 ? null : objetoNuevoMarcas;
    }



    const buscarEnTabla = (palabraABuscar) => {
        let palabra = palabraABuscar.target.value;
        if (palabra !== "") {
            if (obtenerMarcasVehiculoAux !== null) {
                let resultadoFiltro = obtenerMarcasVehiculoAux.filter((item) => {
                    return item.MARCA.toUpperCase().includes(palabra.toUpperCase()) ||
                        item.MARCA.toUpperCase() === palabra.toUpperCase()
                })
                if (resultadoFiltro.length > 0) {
                    setObtenerMarcasVehiculo(modelarDatos(resultadoFiltro));
                } else {
                    setObtenerMarcasVehiculo(null);
                }

            }
        } else {
            setObtenerMarcasVehiculo(modelarDatos(obtenerMarcasVehiculoAux));
        }
    }

    const efectoBotonRemove = (idControl, idBoton) => {
        let controlBuscador = idControl === "" ? "" : document.getElementById(idControl).value;
        let activarEfecto = controlBuscador.trim() === "" ? false : true;

        if (activarEfecto) {
            document.getElementById(idBoton).style.visibility = "visible";
        } else {
            document.getElementById("buscadorMarcaVeh").value = "";
            setObtenerMarcasVehiculo(modelarDatos(obtenerMarcasVehiculoAux));

            document.getElementById(idBoton).style.visibility = "hidden";
        }
    }



    if (!hayMarcasVehiculo && props.ABRIR_FICHA) {
        setHayMarcasVehiculo(true)
        /*
                if (marcas !== null) {
                    setObtenerMarcasVehiculoAux(marcas.MARCAS);
                    setObtenerMarcasVehiculo(modelarDatos(marcas.MARCAS));
                } else {
                    setObtenerMarcasVehiculo(null);
                }
                
        */

        ObtenerListaMarcasTecdocEnAPI(10000, 1, 1, "A", null).then(marcas => {
            if (marcas.REGISTROS !== undefined && marcas.REGISTROS !== null && marcas.REGISTROS.length > 0) {
                setObtenerMarcasVehiculoAux(marcas.REGISTROS);
                setObtenerMarcasVehiculo(modelarDatos(marcas.REGISTROS));
            } else {
                setObtenerMarcasVehiculo(null);
            }
        })


    } else {
        if (!props.ABRIR_FICHA && hayMarcasVehiculo) {
            setObtenerMarcasVehiculo([])
            setHayMarcasVehiculo(false)

            if (document.getElementById("buscadorMarcaVeh") !== null) {
                document.getElementById("buscadorMarcaVeh").value = "";
            }
        }
    }

    return (
        <div>
            <Drawer
                width={"40%"}
                onClose={() => { props.HAY_HARACA_SELECCIONADA ? props.CERRAR_FICHA(false) : props.CERRAR_FICHA(false); props.CERRAR_FICHA_PADRE(false) }}
                visible={props.ABRIR_FICHA}
                closable={false}
                placement={"right"}
                bodyStyle={{ padding: '0px' }}
                style={{ zIndex: '999999', color: '#fff' }}>


                <div className='containerHeaderDrawer'>
                    <div className='itemHeaderDrawer1'>
                        <CloseOutlined onClick={(e) => { props.HAY_HARACA_SELECCIONADA ? props.CERRAR_FICHA(false) : props.CERRAR_FICHA(false); props.CERRAR_FICHA_PADRE(false) }}></CloseOutlined>
                        <div> {props.title}</div>
                    </div>
                </div>


                <div className="p-3" >

                    <div className="grid-container mb-3 mdb-skin" style={{ backgroundColor: '#eee', marginTop: '2px' }}>
                        <div className="grid-item">
                            <input id="buscadorMarcaVeh" className="form-control" type="text" aria-label="Search" placeholder={traducirPagina("Buscar_por_marcas")} style={{ backgroundColor: "transparent", width: '390px', border: '0px', height: '100%', color: '#000' }} autoComplete="off" onChange={(e) => { buscarEnTabla(e); efectoBotonRemove("buscadorMarcaVeh", "closeBuscadorMarcaVeh") }} />
                        </div>

                        <div className="grid-item" >
                            <MDBBtn id="closeBuscadorMarcaVeh" onClick={e => { efectoBotonRemove("", "closeBuscadorMarcaVeh") }} style={{ border: '0', padding: '6px 5px 5px 7px', margin: '0', boxShadown: 'none', visibility: 'hidden' }} className="btn-matriculav2">  <CloseOutlined style={{ color: '#666', cursor: 'pointer', fontSize: '20px' }} />  </MDBBtn>
                        </div>

                        <div className="grid-item barraLateral" ></div>

                        <div className="grid-item">
                            <MDBBtn style={{ border: '0', padding: '6px 1px 5px 7px', margin: '0', boxShadown: 'none' }} className="btn-matricula">  <SearchOutlined style={{ color: '#666', cursor: 'pointer', fontSize: '20px' }} />  </MDBBtn>
                        </div>
                    </div>


                    {
                        <div style={{ height: (configApp.height - 160).toString() + "px", overflow: 'auto' }}>


                            {obtenerMarcasVehiculo === null ?
                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '70vh' }}> <h3>Actualmente no hay registros</h3> </div>
                                :
                                obtenerMarcasVehiculo.length > 0 ?
                                    obtenerMarcasVehiculo.map((item, i) =>
                                        <div key={i} id={i} style={{ color: '#000', fontSize: '16px', fontWeight: '500', marginBottom: '10px' }}>
                                            {item.lista.map((row, i) =>
                                                <div style={{ float: 'left', padding: '5px', width: '33%', cursor: 'pointer' }} className="efectoContainerVehiculo" onClick={() => {

                                                    props.MARCA_SELECCIONADA(row.Marca)

                                                    props.MARCA_ACTUAL(row)
                                                    props.BUSCAR_GRUPO(row.Codigo)

                                                    props.CERRAR_FICHA(false)
                                                }} >
                                                    {row.Marca}
                                                </div>
                                            )}
                                        </div>

                                    )
                                    :
                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '70vh', color: '#000' }}> <div color="mdb-color darken-3" className="spinner-border  fast" role="status" disabled /> </div>
                            }
                        </div>
                    }
                </div>
            </Drawer>
        </div>

    )
}

ManteniminetoMarcas.propTypes = {
    title: PropTypes.string,
    ABRIR_FICHA: PropTypes.bool,
    CERRAR_FICHA: PropTypes.func,
    ID_SOCIO: PropTypes.number,
    MARCA_SELECCIONADA: PropTypes.func,
    MARCA_ACTUAL: PropTypes.func,
    BUSCAR_GRUPO: PropTypes.func,
    HAY_HARACA_SELECCIONADA: PropTypes.bool,
    CERRAR_FICHA_PADRE: PropTypes.func,

};

const mapStateToProps = (state, props) => {
    return {
        codmotorizacion: state.codmotorizacion,
        configApp: state.configApp,
        props: props,

    };
}

export default connect(mapStateToProps)(ManteniminetoMarcas);